<div dropdown placement="bottom left"
  [insideClick]="insideClick"
  class="position-relative epic-colors-dropdown-list-wrapper">
  <div dropdownToggle class="icon-md epic-color-picker" [ngStyle]="{'background-color': control?.value}"></div>
  <div *dropdownMenu class="dropdown-menu dropdown-menu-left epic-color-dropdown">
    <app-color-picker (colorChange)="selectColor($event)"></app-color-picker>
  </div>
</div>
